import type { ReactNode } from 'react';

/** Dimmed dash for an absent value, so it reads as "no data" rather than as data. */
export function MissingValue(): ReactNode {
    return <span className="text-muted-foreground font-normal">-</span>;
}
